mcWeb.shipment = new function () { };

mcWeb.shipment.events = {
    reloadShipment: "mcWeb.shipment.reloadShipment",
    onChangedShipment: "mcWeb.shipment.onChangedShipment",
    onSelectedShipment: "mcWeb.shipment.onSelectedShipment",
    onSelectedShipmentForCustomerRefresh: "mcWeb.shipment.onSelectedShipmentForCustomerRefresh"
};